<template>
    <div style="padding-bottom:50px">
        <div @click="redirectPreviousUrl"
            style="font-size:14px;text-decoration: none;width:30%;line-height:30px;color:#98c14b;display:flex;cursor:pointer">
            <p>
                <a-icon type="double-left" />
            </p>
            <p>Go Back </p>

        </div>
        <div style="display:flex;justify-content: flex-end;">
            <a-button @click="downloadReceipt" style="border-raduis:5px; background: #418a49; color:#fff;"> Download
                <a-icon type="download" /> </a-button>
        </div>
        <div id="printMe" style="margin-top:50px;background:#fff; padding:30px;">
            <div class="container">
                <!-- Content here -->
                <div class="row">
                    <div class="col">
                        <div class="row">
                            <div class="col">
                                <!-- <div style="background-color:#ccc;;width: 70px; height: 37px;margin-top:5px;"></div> -->
                            </div>
                            <div class="col">
                                <!-- <span style="font-size:20px; font-weight:bolder">{{supplierDetails.name}}</span>
                                <span style="font-size:13px;display:block">{{supplierDetails.address}}</span> -->
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div style="float:right">
                            <span style="font-size:20px; font-weight:bolder">PURCHASE ORDER</span>
                            <span style="font-size:16px;display:block">DATE: {{ currentDate }}</span>
                            <!-- <span style="font-size:16px;display:block">#34566</span> -->
                        </div>
                    </div>
                </div>
                <div class="row justify-content-md-center mt-3">
                    <div class="col">
                        <div style="border: 2px solid #ccc;padding: 20px;">
                            <div class="row">
                                <div class="col-4" style="font-weight:bolder;font-size:18px;">
                                    Supplier:
                                </div>
                                <div class="col-8">
                                    <span style="font-weight:bolder;font-size:16px;">
                                        {{ supplierPreviewName }}
                                    </span>
                                    <span style="font-size:16px;display:block">
                                        {{ supplierAddress }}
                                    </span>
                                    <span style="font-size:16px;display:block">
                                        {{ supplierCity }}
                                    </span>
                                    <span style="font-size:16px;display:block">
                                        {{ supplierCountry }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div style="border: 2px solid #ccc;padding: 20px;">
                            <div class="row">
                                <div class="col-4" style="font-weight:bolder;font-size:18px;">
                                    Ship To:
                                </div>
                                <div class="col-8">
                                    <span style="font-weight:bolder;font-size:16px;">
                                        {{ destionation }}
                                    </span>
                                    <span style="font-size:16px;display:block">
                                        {{ shipAddress }}
                                    </span>
                                    <span style="font-size:16px;display:block">
                                        {{ shipCity }}
                                    </span>
                                    <span style="font-size:16px;display:block">
                                        {{ shipCountry }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-top:30px;display: flex; justify-content: space-between">
                    <div class="col">
                        <div style="font-weight:bolder">Shipping Method</div>
                        <div style="padding-left: 38px;padding-right: 38px;">{{ shippingMethod }}</div>
                    </div>

                    <div class="col" style="text-align: end;" :span="12">
                        <div style="font-weight:bolder">Delivery Date</div>
                        <div style="">
                            {{ deliveryDate }}
                        </div>
                    </div>
                </div>
                <div style="margin-top:30px">
                    <table class="table table-striped table-hover table-bordered">

                        <thead>
                            <tr>
                                <th scope="col">Product Name</th>
                                <th scope="col">Quantity</th>
                                <th scope="col">UnitPrice</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="product in tableData" :key="product.id">
                                <td>{{ product.brandName }}</td>
                                <td>{{ product.unitQuantity }}</td>
                                <td>{{ product.unitPrice }}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
                <div style="margin-top:40px">
                    <div class="row">
                        <div class="col">
                            <p style="font-weight:bolder">Shipping Terms:</p>
                            <p>{{ shippinTerm }}</p>
                        </div>
                        <div class="col">
                            <div class="row" style="display:flex;justify-content: flex-end;">
                                <div class="col" style="font-weight:bolder;font-size: 19px;" :span="8">Sub Total: </div>
                                <div class="col" :span="12" style="font-size: 19px;">Ksh {{ displayTotalAmount }}</div>
                            </div>
                            <div class="row" style="display:flex;justify-content: flex-end;">
                                <div class="col" style="font-weight:bolder;font-size: 19px;" :span="8">Discount: </div>
                                <div class="col" style="display:flex; height:20px;font-size: 19px;" :span="12">
                                    - {{ discount }}
                                </div>
                            </div>
                            <div class="col" style="display:flex;justify-content: flex-end;padding-top:30px">
                                <div class="col-8" style="font-weight:bolder;font-size: 25px;">Grand Total: </div>
                                <div class="col-6" style="font-weight:bolder;font-size: 25px;">Ksh {{ displayGrandTotal }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <a-modal class="modalStyle" :visible="addProductVisible" :footer="null" @cancel="handleAddProductCancel">
                <h4 style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;">Download </h4>
                <div>
                    <h5>Are you sure you want to download?</h5>
                    <div style="display:flex;justify-content:center;margin-top:20px">
                        <a-button @click="submitReceipt"
                            style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                            Download
                        </a-button>
                    </div>

                </div>
            </a-modal>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

const columns = [
    {
        title: 'Product Name',
        dataIndex: 'brandName',
        key: "brandName",
        // scopedSlots: { customRender: 'name' },
        // width: 200,
    },
    // {
    //     title: 'Category',
    //     dataIndex: 'category',
    //     // scopedSlots: { customRender: 'category' },
    //     key:"category",
    // 	width: 200,
    // },
    {
        title: 'Quantity',
        dataIndex: 'unitQuantity',
        key: "unitQuantity",
        // scopedSlots: { customRender: 'quantity' },
        // width: 200,
    },
    {
        title: 'Selling Price',
        dataIndex: 'unitPrice',
        key: "unitPrice",
        // scopedSlots: { customRender: 'unitPrice' },
        // width: 200,
    },
    // {
    //     title: 'Line Total',
    //     dataIndex: 'lineTotal',
    //     key:"lineTotal"
    // 	// width: 200,
    // },

]

export default {
    name: "QuickActionReceiptPreView",
    data() {
        return {
            columns,
            tableData: [],
            tableLoading: false,
            discount: 0,
            deliveryDate: "",
            supplierName: "",
            supplierPreviewName: '',
            addProductVisible: false,
            supplierAddress: "",
            supplierCity: "",
            supplierCountry: "",
            destionation: "",
            shipAddress: "",
            shipCity: "",
            shipCountry: "",
            shippinTerm: "",
            supplierDetails: {}
        };
    },
    computed: {
        ...mapGetters(['getPreViewData']),
        displayTotalAmount() {
            // console.log("in tableData |", this.tableData)
            const itemAmount = this.tableData.map(item => {
                if (item.unitPrice && item.unitQuantity) {
                    return parseFloat(item.unitPrice) * parseFloat(item.unitQuantity)
                } else {
                    return 0
                }
            })
            // console.log("in each itemAmount |", itemAmount)
            const totalAmt = itemAmount.reduce((acc, item) => acc + item, 0);
            // console.log("in computed totalAmt |", totalAmt)
            return parseFloat(totalAmt).toFixed(2)

        },
        currentDate() {
            return moment().format("DD-MMM-YYYY")
        },

        displayGrandTotal() {
            return (this.displayTotalAmount - this.discount).toFixed(2)
        }
    },
    methods: {
        ...mapActions(['setPreviewInfo', 'generatePurcharseOrder']),
        redirectPreviousUrl() {
            this.$router.back()
        },
        handleAddProductCancel() {
            this.addProductVisible = false
        },
        downloadReceipt() {

            this.addProductVisible = true
            // this.$htmlToPaper('printMe');
        },
        submitReceipt() {

            // console.log("getPreViewInfo | ", this.getPreViewInfo)
            let productLine = {};
            this.tableData.map(response => {
                // console.log("product | ",response)
                productLine[response.id] = {
                    quantity: parseFloat(response.unitQuantity),
                    unitPrice: parseFloat(response.unitPrice)
                }
            })
            // console.log("productLine | ", productLine)
            let request_data = {
                supplierId: this.supplierName,
                supplierAddress: this.supplierAddress,
                sellerAddress: "",
                productLine: productLine
            }
            this.generatePurcharseOrder(request_data).then(response => {
                if (response.status === 200) {
                    this.$htmlToPaper('printMe');
                    this.addProductVisible = false;
                } else {
                    // console.log("Error | ", response)
                }
            }, error => {
                console.log("Error | ", error)
            })
        },
    },
    created() {
        // console.log("getPreViewData | ", JSON.parse(this.getPreViewData))
        if (this.getPreViewData) {
            let result = JSON.parse(this.getPreViewData)
            this.discount = result.discount ? result.discount : '',
                this.deliveryDate = result.deliveryDate ? result.deliveryDate : '',
                this.supplierName = result.supplierName ? result.supplierName : '',
                this.supplierAddress = result.supplierAddress ? result.supplierAddress : '',
                this.supplierPreviewName = result.supplierPreviewName ? result.supplierPreviewName : '',
                this.supplierCity = result.supplierCity ? result.supplierCity : '',
                this.supplierCountry = result.supplierCountry ? result.supplierCountry : '',
                this.destionation = result.destionation ? result.destionation : '',
                this.shipAddress = result.shipAddress ? result.shipAddress : '',
                this.shipCity = result.shipCity ? result.shipCity : '',
                this.shipCountry = result.shipCountry ? result.shipCountry : '',
                this.shippingMethod = result.shippingMethod ? result.shippingMethod : '',
                this.shippinTerm = result.shippinTerm ? result.shippinTerm : '',
                this.tableData = result.tableData
            // console.log("this.tableData  | ", this.tableData )
            // this.supplierDetails = this.getPreViewInfo.supplierDetails
        }

    }
}
</script>

<style scoped>
.editable-cell {
    position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
    padding-right: 24px;
}

.editable-cell-text-wrapper {
    padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
    position: absolute;
    right: 0;
    width: 20px;
    cursor: pointer;
}

.editable-cell-icon {
    line-height: 18px;
    display: none;
}

.editable-cell-icon-check {
    line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
    display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
    color: #108ee9;
}

.editable-add-btn {
    margin-bottom: 8px;
}

a {
    text-decoration: none;
}

@media print {
    @page {
        size: landscape
    }
}
</style>